import React, { useState, useEffect } from "react"
// Not sure why this is required but removing this breaks the styles.
import styled from "styled-components/macro"
import { ThemeProvider } from "styled-components"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { GlobalStyle, ViewRow, ViewColumn, HeaderTitle, HeaderSubTitle, Title } from "../components/styled/styles"
import { lightTheme, darkTheme } from "../components/themes"
import Sidebar from "../components/sidebar"
import Toggle from "../components/Toggle"
import Banner from "../images/banner.png"
import News from "../components/NewsComponent"
import news from "../constants/news"
import community from "../constants/community"

const IndexPage = props => {
  const [theme, setTheme] = useState("light")
  const setMode = mode => {
    window.localStorage.setItem("theme", mode)
    setTheme(mode)
  }
  const themeToggler = () => {
    theme === "light" ? setMode("dark") : setMode("light")
  }
  useEffect(() => {
    const localTheme = window.localStorage.getItem("theme")
    localTheme && setTheme(localTheme)
  }, [])
  const [expanded, setExpanded] = useState(false)
  const [currentItem, setCurrentItem] = useState(false)
  const [selectedBanner, setSelectedBanner] = useState(undefined)
  function handleClick(expanded, ability) {
    setExpanded(expanded)
    setCurrentItem(ability)
  }
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <Layout theme={theme === "light" ? lightTheme : darkTheme}>
        <React.Fragment>
          <GlobalStyle theme={theme === "light" ? lightTheme : darkTheme} />
          <SEO title={props.pageName} />
          <ViewRow
            css={`
              width: 100%;
            `}
          >
            {/** Side bar */}
            <Sidebar expanded={expanded} theme={theme === "light" ? lightTheme : darkTheme} />
            <ViewColumn
              css={`
                width: -webkit-fill-available;
              `}
            >
              <ViewRow
                css={`
                  justify-content: space-between;
                  align-items: center;
                  margin: 0 0 0 24px;
                `}
              >
                <ViewColumn>
                  <HeaderTitle theme={theme === "light" ? lightTheme : darkTheme}>CATALYST BLACK WIKI</HeaderTitle>
                  <HeaderSubTitle theme={theme === "light" ? lightTheme : darkTheme}>Home</HeaderSubTitle>
                </ViewColumn>
                <ViewRow onClick={themeToggler}>
                  <Toggle theme={theme === "light" ? lightTheme : darkTheme} toggleTheme={themeToggler} />
                </ViewRow>
              </ViewRow>
              <ViewRow
                css={`
                  height: 300px;
                  margin: 24px;
                  border-radius: 24px;
                  background-image: url(${Banner});
                  background-position: center;
                `}
              />
              <Title
                css={`
                  text-align: left;
                  margin: 0 0 0 24px;
                `}
              >
                NEWS
              </Title>
              <ViewRow
                css={`
                      max-width: 1104px;
                      height: fit-content;
                      flex-wrap: wrap;
                      margin: 16px 16px 0 0;
                    `}
              >
                {news.map((item, index) => (
                    <News
                      key={index}
                      theme={theme === "light" ? lightTheme : darkTheme}
                      link={item.link}
                      image={item.image}
                      title={item.title}
                      date={item.date}
                    />
                ))}
              </ViewRow>

              <Title
                css={`
                  text-align: left;
                  margin: 10px 0 0 24px;
                `}
              >
                COMMUNITY
              </Title>
              <ViewRow
                css={`
                      max-width: 1104px;
                      height: fit-content;
                      flex-wrap: wrap;
                      margin: 16px 16px 0 0;
                    `}
              >
                {community.map((item, index) => (
                    <News
                      key={index}
                      theme={theme === "light" ? lightTheme : darkTheme}
                      link={item.link}
                      image={item.image}
                      title={item.title.toUpperCase()}
                      date={item.date}
                    />
                ))}
              </ViewRow>
            </ViewColumn>
          </ViewRow>
        </React.Fragment>
      </Layout>
    </ThemeProvider>
  )
}

export default IndexPage
